<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()">
      <span *ngIf="appInUso" class="title-container">
        {{appInUso.titolo}}
        <span *ngIf="user!=null && user.tipoRuolo==1" style="font-style: italic;"> - Docente {{ user?.dipartimentoDesc }}</span>
        <span *ngIf="user!=null && user.tipoRuolo==2" style="font-style: italic;"> - Direttore {{ user?.dipartimentoDesc }}</span>
        <span *ngIf="user!=null && user.tipoRuolo==3" style="font-style: italic;"> - Personale tecnico amministrativo</span>
        <span *ngIf="user!=null && user.tipoRuolo==4" style="font-style: italic;"> - Rettore</span>
        <span *ngIf="user!=null && user.tipoRuolo==5" style="font-style: italic;"> - Vice Direttore {{ user?.dipartimentoDesc }}</span>
      </span>
    </a>
  </div>
  <!-- <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
  </nb-select> -->
</div>

<div class="header-container">

  <!-- <select #selectRole (change)="cambiaRuolo(selectRole.value)"
          class="btn btn-primary btn-actions">
    <option value="1" [selected]="user.actionRole == 1">DOCENTE</option>
    <option *ngIf="user.tipoRuolo==2" value="2" [selected]="user.actionRole == 2">DIRETTORE</option>
    <option value="3" [selected]="user.tipoRuolo == 3">UPDC</option>
    <option *ngIf="user.tipoRuolo==4" value="4" [selected]="user.actionRole == 4">RETTORE</option>
  </select> -->
  <div class="position-relative mr-3">
    <i class="far fa-bell color-primary fs-1_5 mr-3 pointer" title="Vedi Notifiche" (click)="openNotifiche(notifiche)"></i>
    <div class="bg-white notifiche-container rounded" [class]="{'open' : viewNotifiche==true}">
      <div class="mb-3">
        <div class="d-flex justify-content-between align-items-center">
          <h6>Notifiche</h6>
          <button class="btn btn-danger" (click)="deleteNotificheProgettiByExtUserIdDestinatario()" *ngIf="notificheList && notificheList.length>0">Elimina tutto</button>
        </div>
        <i class="fas fa-trash text-danger pointer" title="ELIMINA NOTIFICHE SELEZIONATE" *ngIf="listaNotificheToRemove && listaNotificheToRemove.length>0" (click)="deleteListNotificheProgettiById()"></i>
      </div>
        <input type="text" class="form-control mb-2" #filtroNotifiche (keyup)="filterNotification(filtroNotifiche.value)" placeholder="Inserisci testo da ricercare">
        <div class="notifiche-container-list" #notifiche>
            <div *ngFor="let notifica of notificheList; let i = index" class="notification" [class]="{'newNotification' : notifica.stato==1, 'd-none' : notifica.visible==false}" (click)="dettaglioNotifica(notifica)">

              <div class="d-flex justify-content-between">
                <!-- <i class="fas fa-times text-danger" (click)="removeNotifica($event, notifica)"></i> -->
                <input type="checkbox" name="notifica-{{i}}" id="notifica-{{i}}" (click)="removeNotifica($event, notifica)">
                <p class="data-notifica text-right">{{notifica.data}}</p>
              </div>

              <p class="testo-notifica">{{notifica.corpoDelMessaggio}}</p>

            </div>
        </div>
    </div>
    <span *ngIf="countNotifiche && countNotifiche>0" class="badge-notifiche">{{countNotifiche}}</span>
</div>
  <nb-actions size="small" *ngIf="user!=null">

    <!-- <nb-action class="control-item">
      <nb-search type="rotate-layout"></nb-search>
    </nb-action>
    <nb-action class="control-item" icon="email-outline"></nb-action>
    <nb-action class="control-item" icon="bell-outline"></nb-action>  -->
    <nb-action class="user-action" *nbIsGranted="['view', 'user']" >
      <nb-user [nbContextMenu]="userMenu"
               [onlyPicture]="userPictureOnly"
               [title]="user?.tipoRuoloDesc"
               [name]="user?.nome + ' ' + user?.cognome"
               [picture]="user?.fotoBase64">
      </nb-user>
    </nb-action>
  </nb-actions>
</div>
